<template>
    <v-card flat tile class="transparent">
        <v-card flat tile class="transparent d-flex flex-nowrap align-center">
            <v-icon class="theme-text timeItem-icon">mdi-close-box</v-icon>
            <v-card flat tile class="timeItem-number transparent theme-title" v-if="element.excluded">{{element.excluded.jersey}}</v-card>
            <v-card flat tile class="timeItem-name transparent theme-title">{{element.excluded ? element.excluded.name : '...'}}</v-card>
        </v-card>
        <v-card flat tile class="transparent d-flex flex-nowrap align-center">
            <v-icon class="theme-text timeItem-icon">mdi-arrow-down-box</v-icon>
            <v-card flat tile class="timeItem-number transparent theme-title" v-if="element.down">{{element.down.jersey}}</v-card>
            <v-card flat tile class="timeItem-name transparent theme-title">{{element.down ? element.down.name : '...'}}</v-card>
        </v-card>
    </v-card>
</template>

<script>
    export default {
        name: 'TimelineExclude',
        props: {
            element: Object,
        },
    }
</script>

<style scoped>
    .timeItem-icon {
        margin-right: 5px;
    }

    .timeItem-number {
        font-size: 14px;
        font-weight: bold;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        margin-right: 5px;
    }

    .timeItem-name {
        font-size: 14px;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>